import React from 'react'
import { Link } from 'react-router-dom'

// images
import Logo from '../../images/logo-2.svg'

const ClickHandler = () => {
  window.scrollTo(10, 0)
}

const Footer = (props) => {
  return (
    <footer className="wpo-site-footer">
      <div className="wpo-upper-footer">
        <div className="container-fluid">
          <div className="row">
            <div
              className="col col-lg-3 col-md-6 col-sm-12 col-12 scroll-text-animation"
              data-animation="fade_from_bottom"
            >
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img src={Logo} alt="blog" />
                </div>
                <p>
                  Born from a passion for quality and style, Fullamoda is more
                  than just a store - we're your gateway to exceptional living.
                </p>
              </div>
            </div>
            <div
              className="col col-lg-3 col-md-6 col-sm-12 col-12 scroll-text-animation"
              data-animation="fade_from_bottom"
            >
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Contact</h3>
                </div>
                {/* <ul> */}
                  <li>info@fullamoda-iq.com</li>
                  <li>+(964) 750 792 9286</li>
                  {/* <li>+(964) 000 000 0000</li> */}
                  <li>Zakho, New Zakho</li>
                  <li>Erbil, Grand Majidi Mall-B1-74 Upper Ground Floor</li>
                  <li>
                    Süleymaniye, G-1-2-3 Upper Ground Floor, Majidi Commercial
                    Center Sulaimania Bakrajo Area
                  </li>
                  <li>Erbil, Koya Street</li>
                {/* </ul> */}
              </div>
            </div>
            <div
              className="col col-lg-3 col-md-6 col-sm-12 col-12 scroll-text-animation"
              data-animation="fade_from_bottom"
            >
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Quick Link</h3>
                </div>
                <ul>
                  {/* <li>
                    <Link onClick={ClickHandler} to="/about">
                      <span className="rolling-text">About Us</span>{' '}
                    </Link>
                  </li> */}
                  {/* <li>
                    <Link onClick={ClickHandler} to="/services">
                      <span className="rolling-text">Services</span>{' '}
                    </Link>
                  </li> */}
                  <li>
                    <Link onClick={ClickHandler} to="/projects">
                      <span className="rolling-text">Products</span>
                    </Link>
                  </li>
                  {/* <li><Link onClick={ClickHandler} to="/blog"><span className="rolling-text">Blog</span> </Link></li> */}
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      <span className="rolling-text">Contact</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="col col-lg-3 col-md-6 col-sm-12 col-12 scroll-text-animation"
              data-animation="fade_from_bottom"
            >
              <div className="widget newsletter-widget">
                <div className="widget-title">
                  <h3>Follow Us</h3>
                </div>
                <div className="social-widget">
                  <ul>
                    <li>
                      <a
                        href="https://www.facebook.com/p/fullamodaErbil-61553922570189/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={ClickHandler}
                        className="instagram-link"
                        aria-label="Our Instagram profile"
                      >
                        <i className="ti-facebook"></i>
                      </a>
                      {/* <Link onClick={ClickHandler} to="#">
                        <i className="ti-twitter-alt"></i>
                      </Link>
                      <Link onClick={ClickHandler} to="#">
                        <i className="ti-linkedin"></i>
                      </Link> */}
                      <a
                        href="https://www.instagram.com/fullamoda.erbil/?hl=en"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={ClickHandler}
                        className="instagram-link"
                        aria-label="Our Instagram profile"
                      >
                        <i className="ti-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container-fluid">
          <div className="row g-0">
            <div className="col col-lg-12 col-12">
              <p className="copyright">
                &copy;2025 Fullamoda. All Rights Reserved.
              </p>
            </div>
            {/* <div className="col col-lg-6 col-12">
                            <ul className="right">
                                <li><Link onClick={ClickHandler} to="/privace"><span className="rolling-text">Privace & Policy</span> </Link></li>
                                <li><Link onClick={ClickHandler} to="/terms"><span className="rolling-text">Terms</span></Link></li>
                                <li><Link onClick={ClickHandler} to="/about"><span className="rolling-text">About us</span></Link></li>
                                <li><Link onClick={ClickHandler} to="/login"><span className="rolling-text">Login</span></Link></li>
                            </ul>
                        </div> */}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
